import { render, staticRenderFns } from "./LanguagesTranslationsExamInterface.vue?vue&type=template&id=0e8abc66&scoped=true&"
import script from "./LanguagesTranslationsExamInterface.vue?vue&type=script&lang=js&"
export * from "./LanguagesTranslationsExamInterface.vue?vue&type=script&lang=js&"
import style0 from "./LanguagesTranslationsExamInterface.vue?vue&type=style&index=0&id=0e8abc66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8abc66",
  null
  
)

export default component.exports